import React from "react";
import { Modal } from "antd";
import { AiOutlineDelete } from "react-icons/ai";
import { RxCross2 } from "react-icons/rx";
import CustomButton from "../Form/CustomButton";

const ConfirmDeleteModal = ({
  onConfirm,
  onCancel,
  visible,
  title,
  content,
  loading = false,
  disabled = false,
}) => {
  return (
    <Modal
      open={visible}
      footer={null}
      closable={false}
      centered
      className="custom-dark-confirm-modal"
    >
      <button
        onClick={onCancel}
        className="absolute right-[10px] top-[10px] w-[20px] h-[20px] text-[#8D8D8D] hover:text-white"
      >
        <RxCross2 size={20} />
      </button>

      <h2 className="text-center text-[18px] font-[600] text-[#FFFFFF] font-['Public Sans'] leading-[22px]">
        {title || "Confirm Deletion"}
      </h2>

      <div className="mt-[12px] flex flex-col items-center">
        <p className="text-[15px] font-[400] text-[#969696] leading-[22px] text-center font-['Public Sans']">
          {content || "Are you sure you want to delete this Artist?"}
        </p>
        <p className="text-[15px] font-[400] text-[#969696] leading-[22px] text-center font-['Public Sans'] mt-1">
          This action cannot be undone.
        </p>
      </div>

      <div className="flex justify-center gap-4 mt-[8px]">
        <CustomButton
          buttonText="Cancel"
          onClick={onCancel}
          className="w-[80px] h-[28px] text-[12px] font-medium text-[#878787] bg-transparent border border-[#878787] rounded-[15px]"
        />
        <CustomButton
          buttonText="Delete"
          onClick={onConfirm}
          icon={<AiOutlineDelete className="w-[14px] h-[14px]" />}
          iconPosition="left"
          className="w-[80px] h-[28px] text-[12px] font-medium text-[#C00707] bg-transparent border border-[#C00707] rounded-[15px]"
          disabled={disabled}
          loading={loading}
        />
      </div>
    </Modal>
  );
};

export default ConfirmDeleteModal;
